import { useEffect, useState } from "react";
import { MdDeleteForever } from "react-icons/md";
import Loader from "../../common/Loader";
import Pagination from "../../common/Pagination";
import axiosInstance from "../../api/axiosInstance.js";
import { notify, Toast } from "../../common/Toast";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const ActivityLog = () => {
  const permission = getUserMenuPermission(13);
  const [isActiveData, setIsActiveData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);
  const userId = sessionStorage.getItem("userId");

  const fetchActivityData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `ActivityLog/GetAll?pageNumber=${currentPage}&pageSize=${pageSize}`
      );
      setIsActiveData(response.data.data);
      setTotalRecords(response.data.totalRecords);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching activity data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`ActivityLog/Delete/${id}`);
      fetchActivityData();
      notify("error", "Menu deleted successfully");
    } catch (err) {
      console.error("Error deleting menu:", err);
    }
  };

  useEffect(() => {
    fetchActivityData();
  }, [currentPage]);

  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        {loading ? (
          <Loader />
        ) : permission.isView ? (
          <div className="overflow-x-auto rounded-lg">
            <table className="w-full min-w-[700px] text-sm text-left border border-gray">
              <thead className="bg-primary text-white tracking-widest text-center font-light">
                <tr>
                  <th className="border border-gray px-4 py-3 whitespace-nowrap">
                    Activity Type
                  </th>
                  <th className="border border-gray px-4 py-3 whitespace-nowrap">
                    Ip Address
                  </th>
                  <th className="border border-gray px-4 py-3 whitespace-nowrap">
                    Message
                  </th>
                  <th className="border border-gray px-4 py-3 whitespace-nowrap">
                    User Name
                  </th>
                  <th
                    className={`${
                      !permission.isDelete ? "hidden" : ""
                    } border border-gray px-4 py-3 whitespace-nowrap`}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {isActiveData?.length > 0 ? (
                  isActiveData.map((act) => (
                    <tr
                      key={act.id}
                      className="border-b hover:bg-gray-50 transition cursor-pointer text-center"
                    >
                      <td className="border border-gray-100 px-4 py-2">
                        {act.activity_Type}
                      </td>
                      <td className="border border-gray-100 px-4 py-2">
                        {act.ip_Address}
                      </td>
                      <td className="border border-gray-100 px-4 py-2 truncate">
                        {act.message}
                      </td>
                      <td className="border border-gray-100 px-4 py-2">
                        {act.user_Name}
                      </td>
                      <td
                        className={`border border-gray-100 py-2 text-center ${
                          !permission.isDelete ? "hidden" : ""
                        }`}
                      >
                        {" "}
                        {permission.isDelete && (
                          <button
                            className="p-2 ml-2 text-danger hover:bg-gray-100 rounded-md"
                            onClick={() => handleDelete(act.id)}
                          >
                            <MdDeleteForever className="w-8 h-8 bg-red-100 p-1 rounded-md hover:bg-red-200 outline-none focus:ring-2 focus:ring-red-500" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center text-red-500 text-lg py-10">
            You don't have permission to view this page.
          </div>
        )}
        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-gray-6">
            Showing {isActiveData?.length + (currentPage - 1) * 10} of{" "}
            {totalRecords} records
          </p>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </>
  );
};

export default ActivityLog;
